import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoItemZmsPage } from '@/features/promotion/pages/PromoItemZmsPage';
import { promoZmSearchSchema } from '@/features/promotion/types/promotion.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/promotion/adjustment/$promoItemId/')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: promoZmSearchSchema,
  component: function PromoItemZmsRoute() {
    const { promoItemId } = Route.useParams();
    const zmSearch = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Promotional Item ZMs">
        <Suspense fallback={<PageLoader />}>
          <PromoItemZmsPage promoItemId={promoItemId} zmSearch={zmSearch} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
